module.exports = __webpack_public_path__ + "media/images/web/home/specs/spec_workshops_1-7fbdec99b320b6c5438fe2cd7dd758b5.jpg";